export default "__VITE_ASSET__2288ef20__"